/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getZoom__anchor
 */
export default () => window.documentViewer.getZoomLevel();
